import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useBillingStore = defineStore('billingStore', {
	state: () => ({
		creditBalanceHistoryList: [],
		creditBalanceHistoryPagination: {}
	}),
	actions: {
		// async getCreditBalanceHistoryList(params) {
		// 	try {
		// 		const res = await axios.get(`${services.billing}credit-balances?${params.toString()}`, { headers: getHeader() });
		// 		// console.log(res);
		// 		if (!_gHlp.isEmpty(res.data.content)) {
		// 			this.creditBalanceHistoryList = res.data.content;
		// 			this.creditBalanceHistoryPagination = res.data.pagination;
		// 		} else {
		// 			this.creditBalanceHistoryList = [];
		// 			this.creditBalanceHistoryPagination = {
		// 				limit: 20,
		// 				page: 1,
		// 				total_data: 0,
		// 				total_page: 1
		// 			};
		// 		}
		// 	} catch (e) {
		// 		this.creditBalanceHistoryList = []

		// 		console.log(e);
		// 	}
		// },
    async getCreditBalanceHistoryList(params){
  try{
    const res = await axios.get(`${services.billing}credit-balances?${params.toString()}`, { headers: getHeader() });
    
    if(!_gHlp.isEmpty(res.data.content)){
    
        const getDateValue = (item) => {
            const d = item.cbh_transaction_date || item.cbh_created_date || item.cbh_created_at || null;
            const parsed = d ? new Date(d) : new Date(0);
            return parsed;
        };

        const sortedData = [...res.data.content].sort((a, b) => {
            const dateA = getDateValue(a);
            const dateB = getDateValue(b);
            return dateB - dateA; 
        });

        this.creditBalanceHistoryList = sortedData;
        this.creditBalanceHistoryPagination = res.data.pagination;
        } else {
            this.creditBalanceHistoryList = [];
            this.creditBalanceHistoryPagination = {
                limit:20,
                page:1,
                total_data:0,
                total_page:1
            };
        }
      } catch(e) {
          this.creditBalanceHistoryList = [];
          console.log(e);
      }
    },
		async createInvoice(params) {
			return await axios.post(services.billing + 'invoice', params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async getInvoices(params) {
			let queryParams = _gHlp.generateQueryParams(params)
			return await axios.get(services.billing + 'invoices?' + queryParams, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async updateInvoice(id, params) {
			return await axios.post(services.billing + 'invoice/' + id, params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async createInvoicePdf(id, params) {
			return await axios.post(services.billing + 'invoice/generate-pdf/' + id, params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async sendInvoiceToEmail(id, params={}) {
			return await axios.post(services.billing + 'invoice/send-to-emails/' + id, params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async createPayment(params) {
			return await axios.post(services.billing + 'payment', params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async getPayments(params) {
			let queryParams = _gHlp.generateQueryParams(params)
			return await axios.get(services.billing + 'payments?' + queryParams, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async getInvoiceCategories(params) {
			let queryParams = _gHlp.generateQueryParams(params)
			return await axios.get(services.billing + 'invoice-category?' + queryParams, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async postInvoiceCategory(params) {
			return await axios.post(services.billing + 'invoice-category', params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async putInvoiceCategory(id, params) {
			return await axios.put(services.billing + 'invoice-category/'+id, params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async getInvoiceCategory(id) {
			return await axios.get(services.billing + 'invoice-category/'+id, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
		async deleteInvoiceCategory(id) {
			return await axios.delete(services.billing + 'invoice-category/'+id, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},
	}
})